export default "* Stopur\n* Evt. kegler\n";